module.exports = __webpack_public_path__ + "img/bnner-20-7-20.97fa83c2.png";